import { call, put, fork, select, take } from 'redux-saga/effects';
import { save, destroy, get } from './common';
import { validUser }          from './validators/user';
import { validHeatTreatment } from './validators/heat_treatment';
import { validClient }        from './validators/client';
import { validMaterial }      from './validators/material';
import { validProduct }       from './validators/product';
import { validTeam }          from './validators/team';
import { validLocation }      from './validators/location';
import { validOrder }         from './validators/order';
import { validSchedule }      from './validators/schedule';
import { validTask }          from './validators/task';
import { validTasksMemo }     from './validators/tasks_memo';
import { validComment }       from './validators/comment';
import { validDeliveryOption } from './validators/delivery_option';
import { validLocationsPerson } from './validators/location';
export default function* rootSaga() {
  // common
  yield fork(save);
  yield fork(destroy);
  yield fork(get);
  // validations
  yield fork(validUser);
  yield fork(validHeatTreatment);
  yield fork(validClient);
  yield fork(validMaterial);
  yield fork(validProduct);
  yield fork(validTeam);
  yield fork(validLocation);
  yield fork(validLocationsPerson);
  yield fork(validOrder);
  yield fork(validSchedule);
  yield fork(validTask);
  yield fork(validTasksMemo);
  yield fork(validComment);
  yield fork(validDeliveryOption);
}
